<template>
  <div ref="container">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    scrollContainerSelector: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      startYPosition: 0,
      currentYPosition: 0,
      eventSentForCurrentPull: false
    }
  },
  mounted() {
    if (this.disabled) {
      return
    }
    this.$refs.container.addEventListener("touchstart", this.swipeStart, false)
    this.$refs.container.addEventListener("touchmove", this.swipe, false)
  },
  beforeUnmount() {
    if (this.disabled) {
      return
    }
    this.$refs.container.removeEventListener("touchstart", this.swipeStart, false)
    this.$refs.container.removeEventListener("touchmove", this.swipe, false)
    document.documentElement.style.overscrollBehavior = "auto"
  },
  methods: {
    swipeStart(event) {
      this.eventSentForCurrentPull = false
      // Prevent Android Chrome from refreshing the whole page on pull to refresh
      document.documentElement.style.overscrollBehavior = "none"

      let closestContainerSelector = null

      if (this.scrollContainerSelector) {
        closestContainerSelector = this.$el.closest(this.scrollContainerSelector)

        if (!closestContainerSelector) {
          console.error(`PullToRefresh: closest container not found for selector: ${this.scrollContainerSelector}`)
        }
      }

      const scrollContainer = closestContainerSelector || document.documentElement
      this.startAtTop = scrollContainer.scrollTop === 0
      this.startYPosition = event.targetTouches[0].screenY
    },

    swipe(event) {
      if (!this.startAtTop || this.eventSentForCurrentPull) {
        return
      }

      this.currentYPosition = event.targetTouches[0].screenY
      const diffY = this.currentYPosition - this.startYPosition

      if (diffY > 100) {
        this.$emit("pull-to-refresh")
        this.eventSentForCurrentPull = true
      }
    }
  }
}
</script>
